<template lang="html">
  <section :id="id" v-if="visible" v-on:click="onSelected">
    <div class="hardcoded-value">
      <mark>{{ exp }}</mark>
    </div>
  </section>
</template>

<script lang="js">
  import { v4 as uuidv4 } from "uuid";
  import dateUtil from "@/utils/date-util";
  import expressionBuilder from "@/views/drag-drop-pages/components/utils/expression-builder";

  export default  {
    name: "hardcoded-date",
    props: {
      id: {
        type: String,
        default: "static-date-" + uuidv4()
      },
      exp: {
        type: String
      }
    },
    watch: {
      exp: function() {
        this.updateDisplay();
      }
    },
    mounted () {
      this.updateDisplay();
    },
    data () {
      return {
        visible: false
      }
    },
    methods: {
      onSelected() {
        if(this.$listeners && this.$listeners["on-search-box-item-selected"]) {
          this.$emit("on-search-box-item-selected", this.getExpression());
        }
      },
      updateDisplay() {
        this.visible = this.isValid();
      },
      isValid() {
        return dateUtil.isValidISO(this.exp);
      },
      getExpression() {
        return expressionBuilder.getStaticDateExpression({value: this.exp});
      }
    }
  }
</script>

<style scoped lang="scss">
  .hardcoded-value {
    overflow: hidden;
    padding: 0.75rem;
  }
</style>
